export enum DocumentOrderType {
  purchaseOrder = 'PO',
  clientOrder = 'CPO',
  clientReturns = 'CR',
  supplierReturns = 'RTS',
  invoicing = 'INC',
  warehouseEntries = 'WR'
}
